export default __webpack_public_path__ + "static/media/dismiss.6b9bf965.svg";